type Media = { type: "image" | "video"; src: string; poster?: string };

export const mediaById: Record<string, Media> = {
  "projektentwicklung": {
    type: "image",
    src: "/media/images/carre-avila.webp",
  },
  "projektleitung-steuerung": {
    type: "image",
    src: "/media/images/projekt-leitung.webp",
  },
  "projektmanagement": {
    type: "image",
    src: "/media/images/projektmanagement.webp",
  },
  "vertrieb-und-vermarktung": {
    type: "image",
    src: "/media/images/vertrieb-und-vermarktung.webp",
  },
  "objektbetreuung-gewahrleistungsmanagement": {
    type: "image",
    src: "/media/images/objektbetreuung.webp",
  },
  "veranstaltungsorganisation-fur-bauprojekte": {
    type: "image",
    src: "/media/images/veranstaltungsorganisation.webp",
  },
};
